import React from "react";
import { useOneTrust } from "../../../utils";
import PageFooter from "../components/PageFooter";
import PopupPageDecoration from "../views/HomeView/PopupPages/PopupPageDecoration";
import "./OneTrustPage.scss";

export default function OneTrustPage({ did, json }) {
  useOneTrust(json);
  return (
    <PopupPageDecoration isVertical={false}>
      <div style={{ padding: 20 }} className="one-trust-page">
        <div id={did} className="otnotice"></div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <PageFooter />
      </div>
    </PopupPageDecoration>
  );
}
